<template>
  <div class="fields fields-no-select" v-on:mouseenter="openState = true" v-on:mouseleave="openState = false">
    <div class="error input-error" v-if="hasError">{{ currentErrorMessage }}</div>
    <div class="input text-input fields" :class="hasValue">
      <input type="text"
             :class="inputClass"
             class="input-finder counters"
             ref="input"
             readonly
             v-model="content"
      />
      <div class="icon">
        <img :src="icon">
      </div>
      <div class="text">
        <div class="title" :class='{noDesc: description === ""}'>{{ title }}</div>
        <div class="description" v-if='description !== ""'>{{ description }}</div>
      </div>
    </div>
    <div class="field-dropdown" :class="{open: openState}">
      <div class="list-item">
        <div class="name-group">
          <span class="item-name">Adultes</span>
          <span class="item-desc">18 ans et plus</span>
        </div>
        <div class="picker-group">
          <minus-svg :disabled="adults <= minAdults" v-on:click="addAdults(-1)"/>
          <div class="counter">{{ adults }}</div>
          <plus-svg :disabled="adults >= maxAdults" v-on:click="addAdults(1)"/>
        </div>
      </div>
      <div class="list-item">
        <div class="name-group">
          <span class="item-name">Enfants</span>
          <span class="item-desc">De 2 à 18 ans</span>
        </div>
        <div class="picker-group">
          <minus-svg :disabled="children <= minChildren" v-on:click="addChildren(-1)"/>
          <div class="counter">{{ children }}</div>
          <plus-svg :disabled="children >= maxChildren" v-on:click="addChildren(1)"/>
        </div>
      </div>
      <div class="list-item">
        <div class="name-group">
          <span class="item-name">Bébés</span>
          <span class="item-desc">-2 ans</span>
        </div>
        <div class="picker-group">
          <minus-svg :disabled="babies <= minBabies" v-on:click="addBabies(-1)"/>
          <div class="counter">{{ babies }}</div>
          <plus-svg :disabled="babies >= maxBabies" v-on:click="addBabies(1)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  hasValue,
  initializable,
  withErrors,
  withEventDispatcher,
  withIcon,
  withPlaceholder
} from "./mixins/input.mixin";
import MinusSvg from "./svg/minus-svg";
import PlusSvg from "./svg/plus-svg";

export default {
  name: "traveler-picker",
  components: {PlusSvg, MinusSvg},
  mixins: [hasValue('content'), withErrors, withIcon, withPlaceholder, withEventDispatcher, initializable],
  props: {
    title: String,
    description: {
      type: String,
      default: ""
    },
    icon: String,
    min: Number,
    max: Number,
    defaultAdults: {
      type: Number,
      default: 2
    },
    defaultChildren: {
      type: Number,
      default: 0
    },
    defaultBabies: {
      type: Number,
      default: 0
    },
    value: Object
  },
  computed: {
    count() {
      return this.adults + this.children + this.babies;
    },
    minAdults() {
      return 1;
    },
    maxAdults() {
      return 5 - this.children;
    },
    minChildren() {
      return 0;
    },
    maxChildren() {
      return 5 - this.adults;
    },
    minBabies() {
      return 0;
    },
    maxBabies() {
      return 1;
    }
  },
  data() {
    return {
      adults: this.defaultAdults,
      children: this.defaultChildren,
      babies: this.defaultBabies,
      openState: false
    }
  },
  mounted() {
    this.updateValue({
      adults: this.defaultAdults,
      children: this.defaultChildren,
      babies: this.defaultBabies
    });
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    addAdults (v) {
      if (this.adults + v > this.maxAdults || this.adults + v < this.minAdults) return;
      this.adults += v;
      this.updateValue({
        adults: this.adults,
        children: this.children,
        babies: this.babies
      });
    },
    addChildren (v) {
      if (this.children + v > this.maxChildren || this.children + v < this.minChildren) return;
      this.children += v;
      this.updateValue({
        adults: this.adults,
        children: this.children,
        babies: this.babies
      });
    },
    addBabies (v) {
      if (this.babies + v > this.maxBabies || this.babies + v < this.minBabies) return;
      this.babies += v;
      this.updateValue({
        adults: this.adults,
        children: this.children,
        babies: this.babies
      });
    }
  },
}
</script>

<style scoped>
  .noDesc {
    margin: auto !important;
  }
  .field-dropdown {
    background: white;
    border: 1px solid black;
    padding: 10px;
    display: grid;
    grid-gap: 10px;
    z-index: 9;
    position: relative;
  }
  .field-dropdown:not(.open) {
    display: none;
  }
  .list-item {
    position: relative;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: auto 68px;
    align-items: center;
    height: 20px;
  }

  .list-item .picker-group {
    display: grid;
    grid-template-columns: 20px 20px 20px;
    grid-gap: 4px;
    align-items: center;
    text-align: center;
  }
  .list-item .picker-group svg {
    position: relative!important;
  }
  .list-item .item-desc {
    color: #999;
  }
  .list-item .item-name {
    font-size: 1.1em;
  }
</style>




// WEBPACK FOOTER //
// src/components/traveler-picker.vue